var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 343,
    viewBox: "0 0 1000 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.381 54.9377L221.271 82.4068L239.609 109.514L173.594 95.0569L129.584 75.5395L68.4594 80.9609L40.3421 104.816L18.3374 129.032L-7.48663e-06 153.97L1.22219 179.271L1.22219 206.378L14.6697 233.124L48.8998 258.063L118.582 243.245L180.929 226.257L244.499 210.354L194.376 230.594L161.369 254.81L156.479 280.472L184.596 305.772L238.386 327.097L305.624 328.543L319.071 298.544L347.188 269.629L385.086 242.883L403.423 266.738L419.315 291.676L429.095 316.977L435.208 343L515.892 326.013L594.132 308.664L671.149 291.315L744.499 272.159L815.403 252.28L881.418 230.956L942.543 208.185L1000 184.331L918.093 177.102L839.854 168.428L762.836 159.753L787.286 134.092L805.623 107.707L816.626 81.3225L827.628 54.5763L834.963 27.8302L834.963 1.44561L729.829 0.722713L625.917 0.722718L520.782 0.722723L415.648 0.722728L310.513 0.722733L205.379 5.11271e-05L205.379 28.1918L216.381 54.9377Z",
    fill: "#F9DACB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTan);
export default __webpack_public_path__ + "static/media/tan.86ab7ba561419bed3c0782df3f9202b1.svg";
export { ForwardRef as ReactComponent };